import axios from 'axios';
import { Store } from '../config/types';

interface ComplaintFormData {
  store_code: string;
  description: string;
  name: string;
  phone_number: string;
  files?: File[];
}

const API_URL = process.env.REACT_APP_API_URL || 'https://qpikir.kz';

export const getStores = async (): Promise<Store[]> => {
  try {
    const response = await axios.get<Store[]>(`${API_URL}/api/stores/`);
    return response.data;
  } catch (error: unknown) {
    if (error && typeof error === 'object' && 'response' in error) {
      const axiosError = error as { response?: { data: unknown } };
      if (axiosError.response?.data) {
        throw axiosError.response.data;
      }
    }
    throw new Error('Не удалось получить список магазинов');
  }
};

export const submitComplaint = async (data: ComplaintFormData) => {
  const formData = new FormData();
  
  // Add text fields
  formData.append('store_code', data.store_code);
  formData.append('description', data.description);
  formData.append('name', data.name);
  formData.append('phone_number', data.phone_number);
  
  // Add files if present
  if (data.files) {
    data.files.forEach(file => {
      formData.append('files', file);
    });
  }

  try {
    const response = await axios.post(`${API_URL}/api/complaints/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: unknown) {
    if (error && typeof error === 'object' && 'response' in error) {
      const axiosError = error as { response?: { data: unknown } };
      if (axiosError.response?.data) {
        throw axiosError.response.data;
      }
    }
    throw new Error('An unexpected error occurred');
  }
}; 


export const fetchStores = async (): Promise<Store[]> => {
  const res = await axios.get(`${API_URL}/api/stores/`);
  return res.data as Store[];
};

export const fetchStoreByCode = async (code: string): Promise<Store> => {
  const res = await axios.get(`${API_URL}/api/stores/${code}/`);
  return res.data as Store;
};